export default __webpack_public_path__ + "static/media/closet5-after2-480w.4f4fe4dc.avif";